import { useMemo } from 'react';

import { useStoreConfigs } from 'commons/api/store-configs';

export type UseIsAppBlockedResult = {
  isBlocked: boolean;
  isLoading: boolean;
};

const useIsAppBlocked = (): UseIsAppBlockedResult => {
  const { data: storeConfigs, isInitialLoading } = useStoreConfigs();

  return useMemo(
    () => ({
      isBlocked: storeConfigs?.hasAppBlocked === true,
      isLoading: isInitialLoading
    }),
    [storeConfigs?.hasAppBlocked, isInitialLoading]
  );
};

export default useIsAppBlocked;
